<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getLanguageChanged">{{refresh()}}</div>
        
        <v-card v-if="$store.getters.getLanguageList">     
            <div v-if="getShowHelpEvent">{{showHelp()}}</div>
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
            <div v-if="needInit">{{initData()}}</div> 

            <div>
                <h2>{{myContent.title}}</h2>
                <v-layout row wrap>
                    <v-flex xs6>
                        <v-card outlined>
                            <div v-html="myContent.assignment"></div>
                            <codemirror class="border-top" ref="myCm" v-model="myContent.requestedFile" 
                                            :options="cmOptions"
                                            >
                            </codemirror>
                        </v-card>
                    </v-flex>
                    <v-flex xs6>
                        <v-card outlined>
                            <div v-html="myContent.requestedFile"></div>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-card>
                    <v-card-title>
                        Checkout
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs6 v-for="(el,index) in myContent.rules_list" :key="index">
                                <p>  
                                    <span v-if="rules_result">
                                        <v-icon v-if="rules_result[index]" color="green">check_circle</v-icon>
                                        <v-icon v-if="!rules_result[index]"  color="red">error</v-icon>
                                    </span>
                                {{el.description}}
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </div>
        </v-card>

        <v-card v-if="showMyHelp">
            <div v-html="myContent.help">
            </div>
            <v-btn @click="showMyHelp = false">Hide Help</v-btn>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
// import { closeSync } from 'fs';
import { codemirror } from 'vue-codemirror'
import * as check_rules from '../../assets/check_rules.js'

export default {   
    data() {
        return {
                myContent:  {
                    title: 'loading...',
                    assignment: 'loading...',
                    requstedFile: 'loading...',
                    authorsFile: 'loading...',
                    help: 'loading...',                   
                    rules_list: [] // settings of rules set in rulesList
                },
                cmOptions: {
                    tabSize: 4,
                    styleActiveLine: true,
                    lineNumbers: true,
                    line: true,
                    mode: 'text/javascript',
                    lineWrapping: true,
                    extraKeys: {'Ctrl-Space': 'autocomplete',
                            'F11'(cm) {
                                cm.setOption("fullScreen", !cm.getOption("fullScreen"))
                            },
                            'Esc'(cm) {
                            if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false)
                        }
                    }
                },
                feedback: null,
                showMyHelp: false,
                needInit : false,
                rules_result: null
        }
    },
    components :{
        codemirror
    },

    computed: 
        mapGetters([
                    'getShowHelpEvent',
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguageList',
                    'getLanguagePrimary',
                    'getLanguageChanged'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        sendContent() {

        },
        initData() {            
            this.needInit = false         
            this.$store.commit('setFeedback', null)   
           
            this.myContent = JSON.parse(this.dcontent.data.content)
            this.myGlobals = JSON.parse(this.dcontent.data.globals)
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            this.rules_result = []
            for (let i = 0; i < this.myContent.rules_list.length; i++) {
                this.rules_result.push(check_rules.check_rule(this.myContent.rules_list[i].rule_id, 
                                                              this.myContent.rules_list[i].content, 
                                                              this.myContent.requestedFile))
            }
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
        },
        showHelp() {
            this.$store.commit('setShowHelpEvent', false)
            this.showMyHelp = true
        },
        refresh() {
            this.$store.commit('setLanguageChanged',false)
            this.initData()
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>

</style>